import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let PiHomeSelect = class PiHomeSelect extends Vue {
    constructor() {
        super(...arguments);
        this.selectVisible = false;
    }
    selectItemClick(val) {
        this.selectVisible = false;
        this.$emit("change", val);
    }
};
__decorate([
    Prop({
        default: () => {
            return {};
        },
    })
], PiHomeSelect.prototype, "selectObj", void 0);
__decorate([
    Prop({ default: "" })
], PiHomeSelect.prototype, "activeSelect", void 0);
__decorate([
    Prop({ default: "bottom" })
], PiHomeSelect.prototype, "placement", void 0);
PiHomeSelect = __decorate([
    Component({
        components: {},
    })
], PiHomeSelect);
export default PiHomeSelect;
